export class GetAllAppTypesRequest {
    PRID: string;
    ASRKEY: string;
    CurrentKxYearID: number;
    NextKxYearID: number;
}